'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /home/ubuntu/socialtravel/shared/~/react/react.js
// module id = 2
// module chunks = 0 1